import { CompanyEntity } from '../common/entity';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';
import { DateTimeUtil } from '../../util/date.util';

export class Lot extends CompanyEntity {
  number!: string;
  productMasterDataId!: string;
  expirationDate?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);

    this.expirationDate = DateTimeUtil.toPureDate(obj.expirationDate);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export interface Lot extends WithCustomFields {}
applyMixins(Lot, [WithCustomFields, Lot]);
